// PERFORMANCE (Mantos PH):
// Antes, ao tocar/clicar na foto, o zoom baixava a versão de 1946px (image.src) e só depois
// aparecia — com a foto a 50% de opacidade e spinner durante a espera.
// Agora o zoom abre na hora usando o arquivo que a galeria já exibiu (image.currentSrc, em cache)
// e, em segundo plano, carrega a versão de alta resolução e troca assim que ela chegar
// (mesma qualidade final de antes). Visual e comportamento do zoom continuam iguais.

var overlay;

// create a container and set the full-size image as its background
function createOverlay(image) {
  overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundColor = 'var(--gradient-background)';

  const fullSrc = image.src;
  const readySrc = image.complete && image.naturalWidth > 0 ? image.currentSrc : '';

  if (readySrc) {
    // Caminho rápido: imagem já está carregada na galeria — zoom imediato.
    overlay.style.backgroundImage = `url('${readySrc}')`;
    image.parentElement.insertBefore(overlay, image);
    if (fullSrc && fullSrc !== readySrc) upgradeOverlay(overlay, fullSrc);
    return overlay;
  }

  // Caminho original (foto ainda não carregada na galeria).
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${fullSrc}`);
  overlay.style.backgroundImage = `url('${fullSrc}')`;

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

// Carrega a versão de alta resolução em segundo plano e troca sem piscar.
function upgradeOverlay(target, url) {
  const hiRes = new Image();
  hiRes.decoding = 'async';
  hiRes.onload = () => {
    if (target.isConnected) target.style.backgroundImage = `url('${url}')`;
  };
  hiRes.src = url;
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
